var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tenancy-opening-hours" }, [
    _vm.openingHours.updatedBy && !_vm.isEditing
      ? _c("div", { staticClass: "last-update__text row" }, [
          _vm._v("\n    " + _vm._s(_vm.lastUpdatedByOn) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "opening-hour-section" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("tenancy.regularOpeningHours")))]),
      _vm._v(" "),
      _c("div", { staticClass: "opening-hour-btn-group" }, [
        !_vm.isEditing && _vm.canEdit
          ? _c("i", {
              staticClass: "fa fa-pencil",
              on: {
                click: function ($event) {
                  _vm.isEditing = true
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.isEditing && _vm.canEdit
          ? _c(
              "button",
              {
                staticClass: "btn-edit btn--withoutcolor",
                attrs: { role: "edit-button" },
                on: {
                  click: function ($event) {
                    _vm.isEditing = true
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.edit")) + "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEditing
          ? _c(
              "button",
              {
                staticClass: "btn-cancel btn--withoutcolor",
                attrs: { role: "cancel-button" },
                on: { click: _vm.cancel },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isEditing
          ? _c(
              "button",
              {
                staticClass: "btn-save btn--withoutcolor",
                attrs: { role: "save-button" },
                on: { click: _vm.save },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.save")) + "\n      "
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    !_vm.isEditing
      ? _c("div", { staticClass: "view-mode" }, [
          (_vm.openingHours.regularWorkingHours || []).length
            ? _c(
                "ul",
                { staticClass: "tenancy-working-hours-list" },
                _vm._l(
                  _vm.openingHours.regularWorkingHours,
                  function (item, index) {
                    return _c("li", { key: index }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("customWorkingDayLabel")(item.workingDayFrom)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      item.workingDayTo
                        ? _c("span", [_vm._v(" - ")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "u-margin-right-small" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("customWorkingDayLabel")(item.workingDayTo)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("customWorkingHourLabel")(
                              item.workingHourFrom
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      item.workingHourTo
                        ? _c("span", [_vm._v(" - ")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("customWorkingHourLabel")(item.workingHourTo)
                          )
                        ),
                      ]),
                    ])
                  }
                ),
                0
              )
            : _c("p", [
                _vm._v("\n      " + _vm._s(_vm.$t("emptyValue")) + "\n    "),
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "tenancy-working-hours" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("tenancy.holidayOpeningHours"))),
            ]),
            _vm._v(" "),
            (_vm.openingHours.holidayWorkingHours || []).length
              ? _c(
                  "ul",
                  { staticClass: "tenancy-working-hours-list" },
                  _vm._l(
                    _vm.openingHours.holidayWorkingHours,
                    function (item, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "holiday-hour-view" },
                        [
                          _c("div", { staticClass: "working-desc-view-mode" }, [
                            _c("span", [_vm._v(_vm._s(item.workingDesc))]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.formattedDate(item.workingDayFrom))
                              ),
                            ]),
                            _vm._v(" "),
                            item.workingDayTo
                              ? _c("span", [_vm._v(" - ")])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "u-margin-right-small" },
                              [
                                _vm._v(
                                  _vm._s(_vm.formattedDate(item.workingDayTo))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("customWorkingHourLabel")(
                                    item.workingHourFrom
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            item.workingHourTo
                              ? _c("span", [_vm._v(" - ")])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("customWorkingHourLabel")(
                                    item.workingHourTo
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }
                  ),
                  0
                )
              : _c("p", [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("emptyValue")) + "\n      "
                  ),
                ]),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "edit-mode" },
          [
            _c("WorkingHours", {
              attrs: {
                hideLabel: true,
                workingHours: _vm.openingHours.regularWorkingHours || [],
                updateValueByPath: _vm.updateTenancyPathField,
                fieldPath: ["regularWorkingHours"],
                checkTimeValidate: false,
              },
            }),
            _vm._v(" "),
            _c("label", [
              _vm._v(_vm._s(_vm.$t("tenancy.holidayOpeningHours"))),
            ]),
            _vm._v(" "),
            _c("HolidayOpeningHours", {
              attrs: {
                hideLabel: true,
                workingHours: _vm.openingHours.holidayWorkingHours || [],
                updateValueByPath: _vm.updateTenancyPathField,
                fieldPath: ["holidayWorkingHours"],
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }